import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/core/services/loading.service';
import { DeviceList } from '../../models/profile';
import { QuestionErrorService } from '../../services/question-error.service';

@Component({
  selector: 'app-my-devices',
  templateUrl: './my-devices.component.html',
  styleUrls: ['./my-devices.component.scss'],
})
export class MyDevicesComponent implements OnInit {
  deviceList: DeviceList[] = [];
  filteredList: DeviceList[] = [];
  databaseError: boolean = false;
  loading: boolean = true;
  constructor(private loadingService: LoadingService,
    private questionErrorService: QuestionErrorService
    , private translateService: TranslateService,
    private router: Router) { }

  ngOnInit() { }

  ionViewDidEnter() {
    this.getDeviceList();
  }
  addFarm() {
    this.router.navigate(["/common/enter-device"], { queryParams: { initialPage: 1 } });
  }
  getDeviceList() {
    this.deviceList = [];
    this.loading = true;
    this.loadingService.showLoading();
    this.questionErrorService.getDeviceList().subscribe(e => {
      if (e.IsSuccess) {
        this.databaseError = false;
        this.deviceList = e.Data;
        this.filteredList = e.Data;
      } else {
        this.databaseError = true;
      }
      this.loading = false;
      this.loadingService.hideLoading();
    }, err => {
      this.databaseError = true;
      this.loading = false;
      this.loadingService.hideLoading();
    });
  }


  onSearchChange(ev) {
    if (!(ev?.detail?.value == null || ev?.detail?.value == undefined)) {
      let query = ev.detail.value.toLowerCase();
      this.filteredList = this.deviceList.filter(t => t.LocationName?.toLowerCase().includes(query)
        || t.DeviceId?.toLowerCase().includes(query) ||
        this.translateService.instant("profile." + t.DeviceType).toLowerCase().includes(query)).map(t => {
          return t;
        });
    }
    else {
      this.filteredList = this.deviceList;
    }
  }

  openDetail(item: DeviceList) {
    let url = this.router.url + "-detail";
    this.router.navigate([url], {
      queryParams: {
        deviceId: item.SensorId,
        deviceType: item.DeviceType
      }
    });
  }
}
